import { Box, Drawer } from '@mui/material';
import { ProvideAnalyticsPrerequisites, ProvideAvailableAnalyticsReports } from 'shared/individualAnalytics';
import { ApprovalDashboardData } from 'types/backend';
import { AnalyticDisplayArea } from './AnalyticsDisplayArea';
import { AnalyticsDrawerHeader } from './AnalyticsDrawerHeader';
import { DrawerHandle } from './DrawerHandle';
import { useAnalyticsAppInfo } from './useAnaltyticsAppInfo';

type AnalyticsDrawerProps = {
    isAnalyticsDrawerOpen: boolean;
    closeAnalyticsDrawer: () => void;
    analyticsDrawerRow: ApprovalDashboardData | null;
};

export function AnalyticsDrawer({
    isAnalyticsDrawerOpen,
    closeAnalyticsDrawer,
    analyticsDrawerRow,
}: AnalyticsDrawerProps) {
    const { prerequisites, options } = useAnalyticsAppInfo();
    if (!analyticsDrawerRow) return null;

    return (
        <ProvideAnalyticsPrerequisites prerequisites={prerequisites} options={options}>
            <ProvideAvailableAnalyticsReports>
                <Drawer anchor={'bottom'} open={isAnalyticsDrawerOpen} onClose={closeAnalyticsDrawer}>
                    <Box sx={{ height: '80vh', display: 'flex', flexDirection: 'column' }}>
                        <DrawerHandle closeDrawer={closeAnalyticsDrawer} />
                        <AnalyticsDrawerHeader analyticsDrawerRow={analyticsDrawerRow} />
                        <AnalyticDisplayArea analyticsDrawerRow={analyticsDrawerRow} />
                    </Box>
                </Drawer>
            </ProvideAvailableAnalyticsReports>
        </ProvideAnalyticsPrerequisites>
    );
}
